import { useForm } from 'react-hook-form';

import { State } from '@/types';

import { TLogosForm } from '../types';

export function useLogosDrawerFormState() {
  const initialValues: Partial<TLogosForm> = {
    name: '',
    description: null,
    logos: [],
    main_logo: '',
    alias: null,
    state: State.Inactive,
    logos_presigned_urls: [],
    include_in_clip_summary: false,
    labels: [],
  };
  const form = useForm<TLogosForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
